import {
  checkMobile,
  SET_DEVICE_CONNECT,
  SET_GPSINFO2,
  SET_IDCARD_STATE,
  SET_ITEMSTATE,
  SET_NFTF_STATE,
  SET_PAGE_STATE,
  SET_PHONE_ALL,
  SocketCommand,
  socketManager,
} from "../../../../components/AppProvider";
import { _O } from "../../../../modules/utils";
import {
  lastLoginInfo,
  setCookie,
  setCookies,
  setCookieWs,
} from "../../../../modules/utils/cookie";
import { closeLoadingLayer } from "../../../common/Layer/Loading";
import { putBodyData } from "../../../Settings/Accessory/Main";

/*
  commnad: String
  data: Json to String
*/
export const webRequest = (command, data) => {
  try {
    if (checkMobile() === "ANDROID") {
      console.log("webRequest START");
      window.java.webRequest(
        JSON.stringify({
          command: command,
          data: JSON.stringify(data),
        })
      );
    } else if (checkMobile() === "IOS") {
      console.log("webRequest START");
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "webRequest",
        data: JSON.stringify({
          command: command,
          data: JSON.stringify(data),
        }),
      });
    }
  } catch (error) {
    console.log("Error " + command + " :: ", error);
    return "0";
  }
};

export const resEvent = (res, dispatch, deviceCfg) => {
  if (res != "") {
    const resData = JSON.parse(res);
    switch (resData.command) {
      case "phoneInfo":
        // 값이 null일때 처리추가
        // if(JSON.parse(getParameter('100')).data || JSON.parse(getParameter('100')).data != null) {
        setCookies(resData.data, 365);
        setCookie("phoneCfg", resData.data, 365);
        dispatch({
          type: SET_PHONE_ALL,
          data: resData.data,
        });

        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload", state: 1 },
        });

        break;
      case "nw102":
        deviceCfg.deviceTypes = resData.data;
        dispatch({ type: SET_DEVICE_CONNECT, data: deviceCfg });
        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload", state: 1 },
        });
        break;
      case "nw201":
        setCookieWs({ isAutologin: true, signUpChannel: "600" });
        if (resData.data.userEmail && resData.data.userEmail != null) {
          _O.Open(
            "/membership/snsLogin/" +
              resData.data.userEmail +
              "/" +
              resData.data.userName +
              "/" +
              resData.data.userID +
              "/" +
              "600"
          );
        } else {
          _O.Open(
            "/membership/appleLogin/" + resData.data.userID + "/" + "600"
          );
        }
        break;
      case "nw302":
        if (resData.data.resData.type === "upload") {
          dispatch({
            type: SET_PAGE_STATE,
            data: { type: "share", state: 0 },
          });
        } else {
          if (resData.data.resData.redirectURL === "") {
            dispatch({
              type: SET_PAGE_STATE,
              data: { type: "reload", state: 1 },
            });
          } else {
            _O.Open("/" + resData.data.resData.redirectURL);
          }
        }
        break;
      case "nw310":
        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload", state: 1 },
        });
        break;
      case "nw502":
        if (resData.data.cookieData != "") {
          lastLoginInfo(resData.data.cookieData);
        }
        break;
      case "nw610":
        closeLoadingLayer();
        if (resData.data.reserved != "") {
          _O.Open(resData.data.reserved);
        }
        break;
      case "nw1000":
        // 혈압기 등록
        dispatch({
          type: SET_PAGE_STATE,
          data: {
            type: "reload",
            state: resData.data.isResult === 200 ? 1 : 2,
          },
        });
        socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());

        break;
      case "nw1001":
        // if (resData.data.isResult === 200) {
        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload", state: 1 },
        });
        // }

        break;
      case "nw2000":
        dispatch({
          type: SET_PAGE_STATE,
          data: {
            type: "reload",
            state: resData.data.isResult === 200 ? 1 : 2,
          },
        });

        socketManager(SocketCommand.GET_BT_STATUS, undefined, putBodyData());
        // if (resData.data.isResult === 200) {
        //   dispatch({
        //     type: SET_PAGE_STATE,
        //     data: { type: "reload", state: 1 },
        //   });
        // }
        break;
      case "nw2001":
        if (resData.data.isResult === 200) {
          dispatch({
            type: SET_PAGE_STATE,
            data: { type: "reload", state: 1 },
          });
        }
        break;

      case "nw3000":
        if (resData.data.isResult === 200) {
          dispatch({
            type: SET_PAGE_STATE,
            data: { type: "reload", state: 1 },
          });
        }
        break;
      case "nw3001":
        if (resData.data.isResult === 200) {
          dispatch({
            type: SET_PAGE_STATE,
            data: { type: "reload", state: 1 },
          });
        }
        break;
      case "webReload":
        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload", state: 1 },
        });
        break;
      case "deleteResult":
        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload", state: 1 },
        });
        break;
      case "itemState":
        dispatch({
          type: SET_ITEMSTATE,
          data: { type: "SET", data: resData.data },
        });
        break;
      case "openNftfRtn":
        dispatch({
          type: SET_NFTF_STATE,
          data: { type: "SET", data: resData.data },
        });

        break;

      case "getGpsRtn":
        dispatch({ type: SET_GPSINFO2, data: resData.data });
        break;

      case "setFilesMergeRtn":
        dispatch({ type: SET_PAGE_STATE, data: { type: "reload", state: 1 } });
        break;
      case "getIdCardRtn":
        console.log("getIdCardRtn:: ", resData);
        dispatch({
          type: SET_IDCARD_STATE,
          data: { type: "SET", data: resData.data },
        });
        break;
    }
  }
};

export const getIdCard = fileName => {
  try {
    if (checkMobile() === "ANDROID") {
      window.java.getIdCard(fileName);
    } else if (checkMobile() === "IOS") {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "getIdCard",
        data: fileName,
      });
    }
  } catch (error) {
    console.log("Error getIdCard:: ", error);
    return "0";
  }
};

export const setIdCard = (file, fileName) => {
  try {
    if (checkMobile() === "ANDROID") {
      window.java.setIdCard(fileName);
    } else if (checkMobile() === "IOS") {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "setIdCard",
        data: JSON.stringify({
          file: encodeURIComponent(file),
          fileName: fileName,
        }),
      });
    }
  } catch (error) {
    console.log("Error setIdCard:: ", error);
  }
};

export const openIdCard = () => {
  try {
    if (checkMobile() === "ANDROID") {
      window.java.openIdCard();
    } else if (checkMobile() === "IOS") {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "openIdCard",
        data: "",
      });
    }
  } catch (error) {
    console.log("Error openIdCard:: ", error);
  }
};

export const setFilesMerge = (frmUsrTkns, toUsrTkn) => {
  try {
    if (checkMobile() === "ANDROID") {
      // window.java.setFilesMerge(frmUsrTkns.split(","), toUsrTkn);
      window.java.setFilesMerge(
        JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        })
      );
    } else if (checkMobile() === "IOS") {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "setFilesMerge",
        data: JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        }),
      });
    }
  } catch (error) {
    console.log("Error openIdCard:: ", error);
  }
};

export const setFilesMergeComplete = (frmUsrTkns, toUsrTkn) => {
  try {
    if (checkMobile() === "ANDROID") {
      // window.java.setFilesMerge(frmUsrTkns.split(","), toUsrTkn);
      window.java.setFilesMergeComplete(
        JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        })
      );
    } else if (checkMobile() === "IOS") {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "setFilesMergeComplete",
        data: JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        }),
      });
    }
  } catch (error) {
    console.log("Error openIdCard:: ", error);
  }
};

export const setFilesMergeCancel = (frmUsrTkns, toUsrTkn) => {
  try {
    if (checkMobile() === "ANDROID") {
      // window.java.setFilesMerge(frmUsrTkns.split(","), toUsrTkn);
      window.java.setFilesMergeCancel(
        JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        })
      );
    } else if (checkMobile() === "IOS") {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "setFilesMergeCancel",
        data: JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        }),
      });
    }
  } catch (error) {
    console.log("Error openIdCard:: ", error);
  }
};

export const setFilesMergeCheckRtn = (frmUsrTkns, toUsrTkn) => {
  try {
    if (checkMobile() === "ANDROID") {
      window.java.setFilesMergeCheckRtn(
        JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        })
      );
    } else if (checkMobile() === "IOS") {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "setFilesMergeCheckRtn",
        data: JSON.stringify({
          frmUsrTkns: frmUsrTkns.split(", "),
          toUsrTkn: toUsrTkn,
        }),
      });
    }
  } catch (error) {
    console.log("Error openIdCard:: ", error);
  }
};
